import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import { history } from '../store'

import {
  fetchSupportTicket,
  closeTicketSupport,
  reviewTicketSupport,
  resolveTicketSupport,
  incidenceTicketSupport,
  repairTicketSupport,
  deleteSupportTicket
} from '../actions/supporttickets'

import '../styles/SupportTicketAdminView.css'

const STATUS_LABELS = {
  OPEN: 'Abierto',
  IN_REVIEW: 'En Revisión',
  IN_INCIDENCE: 'En Incidencia',
  IN_REPAIR: 'En Reparación',
  RESOLVED: 'Resuelto',
  CLOSED: 'Cerrado',
}

const PRIORITY_LABELS = {
  LOW: 'Baja',
  MEDIUM: 'Media',
  HIGH: 'Alta',
  CRITICAL: 'Crítica',
}

const CATEGORY_LABELS = {
  COINS: 'Pago Monedas',
  BILLS: 'Pago Billetes',
  TPV: 'Pago Tarjeta',
  SCREEN_OFF: 'Pantalla Apagada',
  SCREEN_BREAK: 'Pantalla Rota',
  SCREEN_TOUCH: 'Táctil No Responde',
  PRINTER_TICKET: 'Impresora Ticket',
  KIOSC_DOOR: 'Kiosco Puerta',
  KIOSC_OFF: 'Kiosco No Enciende',
  OTHER: 'Otro',
}

class SupportTicketDetailsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      closeConfirmShown: false,
      deleteConfirmShown: false,
      showActuationModal: false,
      actuationAction: null,
      actuationText: '',
      reviewPriority: '',
    }

    this.handleClose = this.handleClose.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.confirmClose = this.confirmClose.bind(this)
    this.confirmDelete = this.confirmDelete.bind(this)
    this.handleActuationSubmit = this.handleActuationSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchSupportTicket(this.props.match.params.id)
  }

  componentDidUpdate(prevProps) {
    if (this.props.supportticketNeedRefresh && !prevProps.supportticketNeedRefresh) {
      this.props.fetchSupportTicket(this.props.match.params.id)
    }
  }

  handleReview() {
    const { reviewPriority } = this.state
    if (!reviewPriority) return
    this.props.reviewTicketSupport(this.props.match.params.id, reviewPriority)
    this.setState({ reviewPriority: '' })
  }

  handleOpenResolveModal() {
    this.setState({ 
      showActuationModal: true, 
      actuationAction: 'resolve',
      actuationText: ''
    })
  }

  handleOpenIncidenceModal() {
    this.setState({ 
      showActuationModal: true, 
      actuationAction: 'incidence',
      actuationText: ''
    })
  }

  handleActuationSubmit() {
    const { actuationAction, actuationText } = this.state
    const id = this.props.match.params.id
    
    if (!actuationText.trim()) {
      alert('Por favor, introduce el texto de actuación')
      return
    }

    if (actuationAction === 'resolve') {
      this.props.resolveTicketSupport(id, actuationText)
    } else if (actuationAction === 'incidence') {
      this.props.incidenceTicketSupport(id, actuationText)
    }

    this.setState({ 
      showActuationModal: false, 
      actuationAction: null, 
      actuationText: '' 
    })
  }

  handleRepair() {
    this.props.repairTicketSupport(this.props.match.params.id)
  }

  handleClose() {
    this.setState({ closeConfirmShown: true })
  }

  confirmClose() {
    this.setState({ closeConfirmShown: false })
    this.props.closeTicketSupport(this.props.match.params.id)
  }

  handleDelete() {
    this.setState({ deleteConfirmShown: true })
  }

  confirmDelete() {
    this.setState({ deleteConfirmShown: false })
    this.props.deleteSupportTicket(this.props.match.params.id)
      .then(() => {
        history.push('/supporttickets')
      })
  }

  render() {
    const { supportticket, error, loading, role } = this.props

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!supportticket || loading) {
      return <LoadingProgress />
    }

    const isAdmin = role === 'ADMIN'
    const isClosed = supportticket.Status === 'CLOSED'

    return (
      <div className="st-detail-view">
        {/* Header */}
        <div className="st-detail-header">
          <div className="st-detail-header-top">
            <h1>
              <i className="fas fa-ticket-alt"></i>
              Ticket #{supportticket.number}
            </h1>
            <Link to="/supporttickets" className="st-detail-back-btn">
              <i className="fas fa-arrow-left"></i>Volver
            </Link>
          </div>
          <div className="st-detail-header-badges">
            <span className={`ticket-status-badge ${supportticket.Status}`}>
              {STATUS_LABELS[supportticket.Status] || supportticket.Status}
            </span>
            <span className={`ticket-priority-badge ${supportticket.Priority}`}>
              {PRIORITY_LABELS[supportticket.Priority] || supportticket.Priority}
            </span>
          </div>
        </div>

        {/* Info grid */}
        <div className="st-detail-grid">
          <div className="st-detail-card">
            <div className="st-detail-card-title">
              <i className="fas fa-info-circle"></i> Información General
            </div>
            <div className="st-detail-card-body">
              <div className="st-detail-field">
                <span className="st-detail-field-label">Número</span>
                <span className="st-detail-field-value">#{supportticket.number}</span>
              </div>
              <div className="st-detail-field">
                <span className="st-detail-field-label">Categoría</span>
                <span className="st-detail-field-value">{CATEGORY_LABELS[supportticket.Category] || supportticket.Category}</span>
              </div>
              <div className="st-detail-field">
                <span className="st-detail-field-label">Cliente</span>
                <span className="st-detail-field-value">{supportticket.Customer && supportticket.Customer.Fullname ? supportticket.Customer.Fullname : 'VACWAY'}</span>
              </div>
              <div className="st-detail-field">
                <span className="st-detail-field-label">Máquina</span>
                <span className="st-detail-field-value">{supportticket.Machine && supportticket.Machine.Serial ? supportticket.Machine.Serial : 'Todas las máquinas'}</span>
              </div>
              <div className="st-detail-field">
                <span className="st-detail-field-label">Creado por</span>
                <span className="st-detail-field-value">{supportticket.User ? supportticket.User.fullname : supportticket.Customer.Fullname}</span>
              </div>
            </div>
          </div>

          <div className="st-detail-card">
            <div className="st-detail-card-title">
              <i className="fas fa-calendar"></i> Fechas y Asignaciones
            </div>
            <div className="st-detail-card-body">
              <div className="st-detail-field">
                <span className="st-detail-field-label">Fecha Apertura</span>
                <span className="st-detail-field-value">{new Date(supportticket.OpenAt).toLocaleString()}</span>
              </div>
              {supportticket.Executor &&
                <div className="st-detail-field">
                  <span className="st-detail-field-label">Ejecutor</span>
                  <span className="st-detail-field-value">{supportticket.Executor.fullname}</span>
                </div>
              }
              {supportticket.ReviewedAt &&
                <div className="st-detail-field">
                  <span className="st-detail-field-label">En Revisión</span>
                  <span className="st-detail-field-value">
                    {new Date(supportticket.ReviewedAt).toLocaleString()}
                    {supportticket.ReviewedBy ? ` — ${supportticket.ReviewedBy.fullname}` : ''}
                  </span>
                </div>
              }
              {supportticket.InIncidenceAt &&
                <div className="st-detail-field">
                  <span className="st-detail-field-label">En Incidencia</span>
                  <span className="st-detail-field-value">
                    {new Date(supportticket.InIncidenceAt).toLocaleString()}
                    {supportticket.InIncidenceBy ? ` — ${supportticket.InIncidenceBy.fullname}` : ''}
                  </span>
                </div>
              }
              {supportticket.InRepairAt &&
                <div className="st-detail-field">
                  <span className="st-detail-field-label">En Reparación</span>
                  <span className="st-detail-field-value">
                    {new Date(supportticket.InRepairAt).toLocaleString()}
                    {supportticket.InRepairBy ? ` — ${supportticket.InRepairBy.fullname}` : ''}
                  </span>
                </div>
              }
              {supportticket.ResolvedAt &&
                <div className="st-detail-field">
                  <span className="st-detail-field-label">Resuelto</span>
                  <span className="st-detail-field-value">
                    {new Date(supportticket.ResolvedAt).toLocaleString()}
                    {supportticket.ResolvedBy ? ` — ${supportticket.ResolvedBy.fullname}` : ''}
                  </span>
                </div>
              }
              {supportticket.ClosedAt &&
                <div className="st-detail-field">
                  <span className="st-detail-field-label">Cerrado</span>
                  <span className="st-detail-field-value">
                    {new Date(supportticket.ClosedAt).toLocaleString()}
                    {supportticket.ClosedBy ? ` — ${supportticket.ClosedBy.fullname}` : ''}
                  </span>
                </div>
              }
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="st-detail-card" style={{ marginBottom: 24 }}>
          <div className="st-detail-card-title">
            <i className="fas fa-file-alt"></i> Descripción
          </div>
          <div className="st-detail-card-body">
            <div className="st-detail-description">
              {supportticket.Description || 'Sin descripción'}
            </div>
          </div>
        </div>

        {/* Actuation */}
        {supportticket.Actuation &&
          <div className="st-detail-card" style={{ marginBottom: 24 }}>
            <div className="st-detail-card-title">
              <i className="fas fa-tools"></i> Actuación Realizada
            </div>
            <div className="st-detail-card-body">
              <div className="st-detail-description">
                {supportticket.Actuation}
              </div>
            </div>
          </div>
        }

        {supportticket.Observations &&
          <div className="st-detail-card" style={{ marginBottom: 24 }}>
            <div className="st-detail-card-title">
              <i className="fas fa-sticky-note"></i> Observaciones
            </div>
            <div className="st-detail-card-body">
              <div className="st-detail-description">
                {supportticket.Observations}
              </div>
            </div>
          </div>
        }

        {/* Actions */}
        {isAdmin && !isClosed &&
          <div className="st-detail-actions-bar">
            <h3><i className="fas fa-cogs"></i> Acciones</h3>
            <div className="st-detail-actions-row">
              {/* OPEN -> Priority select + Review button */}
              {supportticket.Status === 'OPEN' &&
                <div className="st-review-action-group">
                  <select
                    className="st-review-priority-select"
                    value={this.state.reviewPriority}
                    onChange={e => this.setState({ reviewPriority: e.target.value })}
                  >
                    <option value="">Seleccionar prioridad...</option>
                    <option value="LOW">Baja</option>
                    <option value="MEDIUM">Media</option>
                    <option value="HIGH">Alta</option>
                    <option value="CRITICAL">Crítica</option>
                  </select>
                  <button
                    className="st-detail-action-btn review"
                    disabled={!this.state.reviewPriority}
                    onClick={() => this.handleReview()}
                  >
                    <i className="fas fa-eye"></i>Revisar
                  </button>
                </div>
              }
              {/* IN_REVIEW -> Resolve or Incidence */}
              {supportticket.Status === 'IN_REVIEW' &&
                <>
                  <button className="st-detail-action-btn resolve"
                    onClick={() => this.handleOpenResolveModal()}>
                    <i className="fas fa-check"></i>Resolver
                  </button>
                  <button className="st-detail-action-btn incidence"
                    onClick={() => this.handleOpenIncidenceModal()}>
                    <i className="fas fa-exclamation-triangle"></i>Poner en Incidencia
                  </button>
                </>
              }
              {/* IN_INCIDENCE -> No repair button (managed through incidences view) */}
              <button className="st-detail-action-btn close-action"
                onClick={this.handleClose}>
                <i className="fas fa-times"></i>Cerrar
              </button>
            </div>
          </div>
        }

        {isAdmin &&
          <div className="st-detail-delete-row">
            <button className="st-detail-delete-btn"
              onClick={this.handleDelete}>
              <i className="fas fa-trash"></i>Eliminar Ticket
            </button>
          </div>
        }

        {/* Confirm close */}
        <Modal isOpen={this.state.closeConfirmShown}
          toggle={() => this.setState({ closeConfirmShown: false })}>
          <ModalHeader toggle={() => this.setState({ closeConfirmShown: false })}>
            Confirmar Cierre
          </ModalHeader>
          <ModalBody>
            <p>¿Estás seguro de cerrar el ticket #{supportticket.number}?</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.confirmClose}>Sí</Button>
            <Button color="secondary" onClick={() => this.setState({ closeConfirmShown: false })}>No</Button>
          </ModalFooter>
        </Modal>

        {/* Confirm delete */}
        <Modal isOpen={this.state.deleteConfirmShown}
          toggle={() => this.setState({ deleteConfirmShown: false })}>
          <ModalHeader toggle={() => this.setState({ deleteConfirmShown: false })}>
            Confirmar Eliminación
          </ModalHeader>
          <ModalBody>
            <p>¿Estás seguro de eliminar permanentemente el ticket #{supportticket.number}?</p>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.confirmDelete}>Eliminar</Button>
            <Button color="secondary" onClick={() => this.setState({ deleteConfirmShown: false })}>Cancelar</Button>
          </ModalFooter>
        </Modal>

        {/* Actuation Modal for Resolve/Incidence */}
        <Modal isOpen={this.state.showActuationModal} toggle={() => this.setState({ showActuationModal: false, actuationText: '' })}>
          <ModalHeader toggle={() => this.setState({ showActuationModal: false, actuationText: '' })}>
            {this.state.actuationAction === 'resolve' ? 'Resolver Ticket' : 'Poner en Incidencia'}
          </ModalHeader>
          <ModalBody>
            <p>
              {this.state.actuationAction === 'resolve' 
                ? 'Describe la actuación realizada para resolver el ticket:' 
                : 'Describe el motivo por el que se pone en incidencia:'}
            </p>
            <textarea
              className="form-control"
              rows={4}
              value={this.state.actuationText}
              onChange={(e) => this.setState({ actuationText: e.target.value })}
              placeholder="Escribe la actuación realizada..."
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleActuationSubmit}>
              {this.state.actuationAction === 'resolve' ? 'Resolver' : 'Poner en Incidencia'}
            </Button>
            <Button color="secondary" onClick={() => this.setState({ showActuationModal: false, actuationText: '' })}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  supportticket: state.supporttickets.supportticket,
  error: state.supporttickets.error,
  loading: state.supporttickets.loading,
  role: state.auth.role,
  supportticketNeedRefresh: state.supporttickets.supportticketNeedRefresh
})

const mapDispatchToProps = dispatch => ({
  fetchSupportTicket: bindActionCreators(fetchSupportTicket, dispatch),
  closeTicketSupport: bindActionCreators(closeTicketSupport, dispatch),
  reviewTicketSupport: bindActionCreators(reviewTicketSupport, dispatch),
  resolveTicketSupport: bindActionCreators(resolveTicketSupport, dispatch),
  incidenceTicketSupport: bindActionCreators(incidenceTicketSupport, dispatch),
  repairTicketSupport: bindActionCreators(repairTicketSupport, dispatch),
  deleteSupportTicket: bindActionCreators(deleteSupportTicket, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SupportTicketDetailsView)
